import React from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import FormInput from "../../../utils/FormInput";
import { FormElementModel } from "../../models/FormElementModel";
import { childRegisterForm } from "./inputsForm/InputChildFormModels";
import EAButton from "../shared/Buttons/EAButton";
import { Child } from "../../models/ParticipantRegistration";
import { useTranslation } from "react-i18next";
import "./style.scss";

interface IProps {
  onSave: (child: Child) => void;
  onCancel?: () => void;
  initialData?: Child;
  isEditing?: boolean;
}

const ChildForm: React.FC<IProps> = ({ onSave, onCancel, initialData, isEditing = false }) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Child>({
    defaultValues: initialData || {
      name: "",
      lastName: "",
      age: undefined,
    },
  });

  const handleSaveChild: SubmitHandler<Child> = (data) => {
    onSave(data);
  };

  return (
    <form onSubmit={handleSubmit(handleSaveChild)} className="child-form">
      <div className="flex-start-center flex-wrap">
        {childRegisterForm(register).map((item: FormElementModel, index: number) => (
          <FormInput key={index} {...item} errors={errors} />
        ))}
      </div>

      <div className="child-form__buttons">
        <EAButton
          title={isEditing ? t("zapisz_zmiany") : t("dodaj_uczestnika")}
          inputType="submit"
          variant="filled"
        />
        {onCancel && (
          <EAButton title={t("anuluj")} onClick={onCancel} variant="outlined" />
        )}
      </div>
    </form>
  );
};

export default ChildForm;

